"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryHeader = exports.OrderHistoryMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var react_1 = require("react");
var context_1 = require("./context");
var styles_1 = require("../../styles");
var base_1 = require("../base");
var HiArrowLeft_1 = require("@react-icons/all-files/hi/HiArrowLeft");
var context_2 = require("../../context/context");
var hooks_1 = require("../../hooks");
function OrderHistoryMenu() {
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var _b = (0, context_1.useOrderHistoryContext)(), setTab = _b.setTab, selectedTab = _b.selectedTab, tabs = _b.tabs;
    var onSelect = (0, react_1.useCallback)(function (item) {
        setTab(item === null || item === void 0 ? void 0 : item.value);
    }, [setTab, setTab]);
    var items = (0, react_1.useMemo)(function () {
        return tabs.map(function (it) {
            return {
                text: it.name,
                value: it.key,
            };
        });
    }, [tabs]);
    return (0, jsx_runtime_1.jsx)(base_1.SelectMenu, { onSelect: onSelect, selected: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.key, items: items });
}
exports.OrderHistoryMenu = OrderHistoryMenu;
var OrderHistoryHeader = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, context_1.useOrderHistoryContext)(), closePreview = _c.closePreview, selectedOrderId = _c.selectedOrderId, isLoading = _c.isLoading;
    var order = (0, hooks_1.useOrderById)(selectedOrderId);
    var t = (0, context_2.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(StyledHeader, __assign({ className: "twap-order-modal-header ".concat(className) }, { children: isLoading ? null : !order ? ((0, jsx_runtime_1.jsx)(OrderHistoryMenu, {})) : ((0, jsx_runtime_1.jsxs)(StyledOrderDetails, { children: [(0, jsx_runtime_1.jsx)(StyledBack, __assign({ onClick: closePreview, className: "twap-order-modal-header-back" }, { children: (0, jsx_runtime_1.jsx)(HiArrowLeft_1.HiArrowLeft, {}) })), (0, jsx_runtime_1.jsxs)(StyledTitle, __assign({ className: "twap-order-modal-header-title" }, { children: ["#", order === null || order === void 0 ? void 0 : order.id, " ", (order === null || order === void 0 ? void 0 : order.isMarketOrder) ? t.twapMarketOrder : t.limitOrder] }))] })) })));
};
exports.OrderHistoryHeader = OrderHistoryHeader;
var StyledOrderDetails = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    justifyContent: "flex-start",
    gap: 5,
});
var StyledTitle = (0, styled_components_1.default)(styles_1.StyledText)({
    fontSize: 14,
    span: {
        opacity: 0.7,
        fontSize: 13,
    },
});
var StyledHeader = (0, styled_components_1.default)(styles_1.StyledRowFlex)({
    justifyContent: "flex-start",
    height: 40,
});
var StyledBack = (0, styled_components_1.default)("button")({
    background: "none",
    border: "none",
    cursor: "pointer",
    svg: {
        width: 18,
        height: 18,
    },
});
